webpackJsonp([2],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ade941b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_gallery__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_gallery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      images: ['../../static/img/gallery/wood1.jpg', '../../static/img/gallery/wood2.jpg', '../../static/img/gallery/wood3.jpg', '../../static/img/gallery/wood4.jpg', '../../static/img/gallery/wood5.jpg', '../../static/img/gallery/wood6.jpg', '../../static/img/gallery/wood7.jpg', '../../static/img/gallery/wood8.jpg', '../../static/img/gallery/wood9.jpg', '../../static/img/gallery/wood10.jpg', '../../static/img/gallery/wood11.jpg', '../../static/img/gallery/wood12.jpg', '../../static/img/gallery/wood13.jpg', '../../static/img/gallery/wood14.jpg', '../../static/img/gallery/wood15.jpg', '../../static/img/gallery/wood16.jpg', '../../static/img/gallery/wood17.jpg', '../../static/img/gallery/wood18.jpg', '../../static/img/gallery/wood19.jpg', '../../static/img/gallery/wood20.jpg', '../../static/img/gallery/wood21.jpg', '../../static/img/gallery/wood22.jpg', '../../static/img/gallery/wood23.jpg', '../../static/img/gallery/wood24.jpg', '../../static/img/gallery/wood25.jpg', '../../static/img/gallery/wood26.jpg', '../../static/img/gallery/wood27.jpg', '../../static/img/gallery/wood28.jpeg'],
      index: null
    };
  },

  components: {
    VueGallery: __WEBPACK_IMPORTED_MODULE_0_vue_gallery___default.a
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(289)(true);
// imports


// module
exports.push([module.i, ".container[data-v-5ade941b]{width:100vw;max-width:1140px;min-height:100vh;margin-top:65px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.image-card[data-v-5ade941b]{width:49vw;max-width:360px;height:49vw;max-height:360px;background-size:cover;background-repeat:no-repeat;background-position:50% 50%;margin:1px;cursor:pointer;-webkit-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out}.image-card[data-v-5ade941b]:hover{opacity:1}@media screen and (min-width:767px){.image-card[data-v-5ade941b]:hover{opacity:.6}}", "", {"version":3,"sources":["/Users/tony/Desktop/projects/woods/src/components/Gallery.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAkB,AAClB,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,6BACE,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,4BAA6B,AAC7B,4BAA6B,AAC7B,WAAY,AACZ,eAAgB,AAChB,2CAA4C,AAC5C,kCAAoC,CACrC,AACD,mCACE,SAAW,CACZ,AAED,oCACA,mCACI,UAAY,CACf,CACA","file":"Gallery.vue","sourcesContent":["\n.container[data-v-5ade941b] {\n  width: 100vw;\n  max-width: 1140px;\n  min-height: 100vh;\n  margin-top: 65px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.image-card[data-v-5ade941b] {\n  width: 49vw;\n  max-width: 360px;\n  height: 49vw;\n  max-height: 360px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  margin: 1px;\n  cursor: pointer;\n  -webkit-transition: opacity .3s ease-in-out;\n  transition: opacity .3s ease-in-out;\n}\n.image-card[data-v-5ade941b]:hover {\n  opacity: 1;\n}\n/*large screen*/\n@media screen and (min-width: 767px) {\n.image-card[data-v-5ade941b]:hover {\n    opacity: .6;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(304);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(290)("5c1555af", content, true);

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-0"
  }, [_c('vue-gallery', {
    attrs: {
      "images": _vm.images,
      "index": _vm.index
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, imageIndex) {
    return _c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: ({
          src: image,
          error: '',
          loading: '../../static/img/preload.jpg'
        }),
        expression: "{\n        src: image,\n        error: '',\n        loading: '../../static/img/preload.jpg'\n      }",
        arg: "background-image"
      }],
      key: imageIndex,
      staticClass: "image-card",
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.5428d5d229178f782824.js